// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3v0uu","header":"ReportDetails_header__3726T","title":"ReportDetails_title__2HD8o","left":"ReportDetails_left__3qd_A"};